import {Howl} from 'howler';

export default class audioPlayer {
    defaultControls = {
        playlistHideButton: 'playlistHideBtn',
        playlistShowButton: 'playlistShowBtn',
        playlistBtns: 'playlistMenuBtn',
        next: 'music-next-button',
        prev: 'music-prev-button',
        pause: 'music-pause-button',
        rewind: 'music-rewind-button',
        fastForward:'music-ff-button',
        play: 'music-play-button',
        stop: 'music-stop-button',
        seek: 'music-bar-timer',
        close: 'closeBtn',
        minimise: 'minimumBtn',
        show: 'showBtn',
        volumeBar: 'music-bar-volume',
        volumeBtn: 'music-volume-button',
        trackTime: 'music-cur-time',
        trackLength: 'music-end-time',
        trackTitle: 'music-title',
        repeatButton: 'repeat-button'
    };

    GLOBAL_CROSSFADE_TIME= 2500;
    GLOBAL_PAUSE_FADE_TIME= 500;
    isPaused = false;
    isMuted = false;
    CurrPlaying;
    self = this;
    pauseElements = [];
    playElements= [];
    GLOBAL_STEP_TIME = 5;
    GLOBAL_RESET_TIMER = 5;
    throbber;
    isLoaded = false;
    keepPlayingLoop = false;
    keepPlayingOne = false;



    constructor(element, howlerConfig = {}, audioFiles = [], controlsConfig = null) {
        this.parentElement = element;
        this.PlayerConfig = howlerConfig;
        this.AudioFiles = audioFiles;
        this.CurrVolume = howlerConfig.volume * 100|| 50;
        this.CurrPlaying = null;
        this.index = 0;
        if(controlsConfig  === null || controlsConfig.isEmptyObject()){
            this.ControlsConfig = this.defaultControls;
        }
        this.initialize();
    }

    initialize() {
        let sourceFiles = [];
        this.AudioFiles.forEach((data) => {
            sourceFiles.push(data.file);
        });
        this.PlayerConfig.html5 = true;
        this.PlayerConfig.preload = true;
        this.PlayerConfig.src = sourceFiles;
        this.PlayerConfig.onunlock =  (function(){this.handleUnlock()}).bind(this);
        this.PlayerConfig.onplay = (function (){this.handlePlay()}).bind(this);
        this.PlayerConfig.onload = (function (){this.handleAudioLoad()}).bind(this);
        this.PlayerConfig.onend = (function (){this.handleAudioEnd()}).bind(this);
        this.PlayerConfig.onpause = (function (){this.handlePause()}).bind(this);
        this.PlayerConfig.onstop = (function (){this.handleStop()}).bind(this);
        this.PlayerConfig.onseek = (function (){this.handleSeek()}).bind(this);
        this.PlayerConfig.onplayerror = (function (){this.handlePlayerError();}).bind(this);
        this.CurrPlaying = this.AudioFiles[0].howl = new Howl(this.PlayerConfig);

        // setup controls
        let controls = Object.keys(this.ControlsConfig);
        controls.forEach((controlKey) => {
            let controlData, controlID;
            let ControlExists = false, isCustomControlObj = false;
            if (Boolean(controlKey)) {
                controlData = this.ControlsConfig[controlKey];
                controlID = '';
                if (controlData instanceof Element) {
                    controlID = controlData.id;
                } else if (typeof controlData == 'string') {
                    controlID = controlData;
                } else if (typeof controlData == 'object') {
                    // clause to catch custom objects within the control
                    controlID = controlData.id;
                    isCustomControlObj = true;
                }
                if (this.parentElement.querySelector('#'+controlID)) {
                    ControlExists = true;
                    const controlElement = this.parentElement.querySelector('#'+controlID);
                }
            }

            if (!ControlExists) {
                this.GenerateDefaultControl(controlKey);
            } else if (isCustomControlObj) {
                this.SetupControlEventHandling(controlData.controlHook, controlData.id, controlData.event);
            } else {
                this.SetupControlEventHandling(controlKey, controlID);
            }

        }, this);

        //Setup GUI
        if(!this.ControlsConfig.trackTitle){
            this.GenerateDefaultControl('trackTitle');
        }

        if(!this.ControlsConfig.trackTime){
            this.GenerateDefaultControl('trackTime');
        }

        if(!this.ControlsConfig.trackLength){
            this.GenerateDefaultControl('trackLength');
        }
    }

    step() {
        if(this.CurrPlaying){
            let seek = Math.round(this.CurrPlaying.seek() || 0);
            let barPercentage;
            barPercentage = Math.round(((seek / this.CurrPlaying.duration() || 0) * 100));
            this.parentElement.querySelector('#'+this.ControlsConfig.trackTime).innerText = this.formatTime(seek);
            this.parentElement.querySelector('#'+this.ControlsConfig.trackLength).innerText = this.formatTime(Math.floor(this.CurrPlaying.duration()));
            this.parentElement.querySelector('#' +this.ControlsConfig.trackTitle).innerText = this.AudioFiles[this.index].title || "Untitled Track";
            this.parentElement.querySelector('#'+this.ControlsConfig.seek).value = barPercentage;
            this.setCSSVariable('audioProgress', barPercentage+'%');
            if(barPercentage >= 100){
                this.handleNextTrack();
            }
        }
        requestAnimationFrame(this.step.bind(this));
    }

    volumeUpdate(VolumePercent) {
        let NewVolume = parseFloat((parseInt(VolumePercent) / 100).toFixed(1));
        this.CurrPlaying.volume(NewVolume);
        this.CurrVolume = VolumePercent;
    }

    seek(per) {
        this.CurrPlaying.seek(this.CurrPlaying.duration() * per);
    }

    mute() {
        Howler.volume(0);
        this.prevVolume = this.CurrVolume;
        this.CurrVolume = 0;
        this.setCSSVariable('volumeProgress', 0+'%');
        this.parentElement.querySelector('#'+this.ControlsConfig.volumeBar).value = 0;
        this.isMuted = true;
    }

    unmute() {
        if (this.prevVolume) {
            this.CurrVolume = this.prevVolume;
        } else {
            this.CurrVolume = 50;
        }
        Howler.volume(this.CurrVolume / 100);
        this.setCSSVariable('volumeProgress', this.CurrVolume+'%');
        this.parentElement.querySelector('#'+this.ControlsConfig.volumeBar).value = this.CurrVolume;
        this.isMuted = false;
    }

    pause() {
        if (this.CurrPlaying) {
            this.CurrPlaying.pause();
            this.isPaused = true;
        }
    }

    play(index = this.index) {
        if (this.CurrPlaying === null) {
            this.PlayerConfig.src = this.AudioFiles[index].file;
            this.CurrPlaying = this.AudioFiles[index].howl = new Howl(this.PlayerConfig);
        }
        this.CurrPlaying.play();

        this.index = index;
        this.isPaused = false;
        requestAnimationFrame(this.step.bind(this));
    }

    next() {
        let index;
        if (this.index + 1 >= this.AudioFiles.length) {
            index = 0;
        } else {
            index = this.index + 1;
        }
        this.skipTo(index);
    }

    resetTrack(){
        this.CurrPlaying.seek(0);
    }

    prev() {
        if(this.CurrPlaying.seek() >= this.GLOBAL_RESET_TIMER){
            this.resetTrack();
        } else {
            let index;
            if (this.index - 1 < 0) {
                index = this.AudioFiles.length;
            } else {
                index = this.index - 1;
            }
            this.skipTo(index)
        }
    }

    rewind() {
        let newTime = (this.CurrPlaying.seek() || 0) - this.GLOBAL_STEP_TIME;
        if(newTime < 0){
            newTime = 0;
        }
        this.CurrPlaying.seek(newTime);
    }

    fastForward(){
        let newTime = (this.CurrPlaying.seek() || 0) + this.GLOBAL_STEP_TIME;
        if(newTime > this.CurrPlaying.duration()){
            newTime = this.CurrPlaying.duration();
        }
        this.CurrPlaying.seek(newTime);
    }

    skipTo(index = this.index) {
        if (this.CurrPlaying) {
            this.CurrPlaying.stop();
            this.CurrPlaying = null;
        }
        this.play(index);
    }

    setupLoadHook(){
        //TODO setup event to trigger the loading of cookie based save system, load listening data and setup player accordingly. v2
    }

    setupEndHook(){
        //TODO setup event to save listening data into cookies, for later use v2
    }
    handleLoad() {
        //TODO v2
    }

    handleEnd() {
        //TODO v2
    }

    saveAudioPlace() {
        //TODO v2
    }

    loadAudioPlace() {
        //TODO v2
    }

    handlePlay(){
        if(this.step){
            requestAnimationFrame(this.step.bind(this));
        }
    }

    handleStop(){
        if(this.step){
            requestAnimationFrame(this.step.bind(this));
        }
    }

    handlePause(){
        if(this.step){
            requestAnimationFrame(this.step.bind(this));
        }
    }

    handleSeek(){
        if(this.step){
            requestAnimationFrame(this.step.bind(this));
        }
    }

    handleAudioLoad(){
        //TODO do something on audio load v2
        this.parentElement.querySelector('#' +this.ControlsConfig.trackTitle).innerText = this.AudioFiles[0].title || "Untitled Track";
        this.parentElement.querySelector('#'+this.ControlsConfig.trackLength).innerText = this.formatTime(Math.round(this.CurrPlaying.duration()));
        this.parentElement.querySelector('#'+this.ControlsConfig.volumeBar).value = this.CurrVolume;
    }

    handleAudioEnd(){
        if(this.AudioFiles.length > 1) {
            this.next();
        } else {
            this.stop();
        }
    }

    handleCrossFade(prevTrack, nextTrack) {
        prevTrack.howl.fade(this.CurrVolume/100, 0, this.GLOBAL_CROSSFADE_TIME, prevTrack);
        nextTrack.howl.fade(0, this.CurrVolume/100, this.GLOBAL_CROSSFADE_TIME, nextTrack);
    }

    handleFadeIn() {
        if(!this.CurrPlaying.playing()){
            this.CurrPlaying.fade(0,this.CurrVolume/100, this.GLOBAL_PAUSE_FADE_TIME, this.index);
        }
    }

    handleFadeOut() {
        if(this.CurrPlaying.playing()){
            this.CurrPlaying.fade(this.CurrVolume/100,0, this.GLOBAL_PAUSE_FADE_TIME, this.index);
        }
    }

    handleContainerMode() {
        //TODO setup system to switch containers based on selected player options, v2
    }

    handlePlayerOptions() {
        //TODO open player options menu, v2
    }


    HandlePlayHook(controlElement, customEvent, customFunction = null) {
        let EventFunction;
        if(customFunction){
            EventFunction = customFunction;
        } else {
            EventFunction = (function (event) {
                event.preventDefault();
                this.playElements.forEach(elem => {
                    if(!elem.classList.contains('hidden')){
                        elem.classList.toggle('hidden');
                    }
                });
                this.pauseElements.forEach(elem => {
                    if(elem.classList.contains('hidden')){
                        elem.classList.toggle('hidden');
                    }
                });
                this.play();
            }).bind(this);
        }
        this.playElements.push(controlElement);
        controlElement.addEventListener(customEvent, EventFunction, this);
    }

    HandleNextHook(controlElement, customEvent, customFunction = null) {
        let EventFunction;
        if(customFunction){
            EventFunction = customFunction;
        } else {
            EventFunction = (function (event) {
                event.preventDefault();
                this.playElements.forEach(elem => {
                    if(!elem.classList.contains('hidden')){
                        elem.classList.toggle('hidden');
                    }
                });
                this.pauseElements.forEach(elem => {
                    if(elem.classList.contains('hidden')){
                        elem.classList.toggle('hidden');
                    }
                });
                this.next();
            }).bind(this);
        }
        controlElement.addEventListener(customEvent, EventFunction, this);
    }

    HandlePrevHook(controlElement, customEvent, customFunction = null) {
        let EventFunction;
        if(customFunction){
            EventFunction = customFunction;
        } else {
            EventFunction = (function (event) {
                event.preventDefault()
                this.playElements.forEach(elem => {
                    if(!elem.classList.contains('hidden')){
                        elem.classList.toggle('hidden');
                    }
                });
                this.pauseElements.forEach(elem => {
                    if(elem.classList.contains('hidden')){
                        elem.classList.toggle('hidden');
                    }
                });
                this.prev();
            }).bind(this);
        }
        controlElement.addEventListener(customEvent, EventFunction, this);
    }

    HandlePauseHook(controlElement, customEvent, customFunction = null) {
        let EventFunction;
        if(customFunction){
            EventFunction = customFunction;
        } else {
            EventFunction = (function (event) {
                event.preventDefault();
                this.playElements.forEach(elem => {
                    if(elem.classList.contains('hidden')){
                        elem.classList.toggle('hidden');
                    }
                });
                this.pauseElements.forEach(elem => {
                    if(!elem.classList.contains('hidden')){
                        elem.classList.toggle('hidden');
                    }
                });
                this.pause();
            }).bind(this);
        }
        this.pauseElements.push(controlElement);
        controlElement.addEventListener(customEvent, EventFunction, this);
    }

    HandleStopHook(controlElement, customEvent, customFunction = null) {
        let EventFunction;
        if(customFunction){
            EventFunction = customFunction;
        } else {
            EventFunction = (function (event) {
                event.preventDefault();
                this.playElements.forEach(elem => {
                    if(elem.classList.contains('hidden')){
                        elem.classList.toggle('hidden');
                    }
                });
                this.pauseElements.forEach(elem => {
                    if(!elem.classList.contains('hidden')){
                        elem.classList.toggle('hidden');
                    }
                });
                this.stop();
            }).bind(this);
        }
        controlElement.addEventListener(customEvent, EventFunction, this);
    }

    HandlePlaylistHideButtonHook(controlElement, customEvent, customFunction = null) {
        let EventFunction;
        if(customFunction){
            EventFunction = customFunction;
        } else {
            EventFunction = (function (event) {
                event.preventDefault()
                this.HidePlaylistMenu();
            }).bind(this);
        }
        controlElement.addEventListener(customEvent, EventFunction, this);
    }

    HandlePlaylistShowButtonHook(controlElement, customEvent, customFunction = null) {
        let EventFunction;
        if(customFunction){
            EventFunction = customFunction;
        } else {
            EventFunction = (function (event) {
                event.preventDefault()
                this.ShowPlaylistMenu();
            }).bind(this);
        }
        controlElement.addEventListener(customEvent, EventFunction, this);
    }

    HandlePlaylistBtnHook(controlElement, customEvent, customFunction = null) {
        let EventFunction;
        if(customFunction){
            EventFunction = customFunction;
        } else {
            EventFunction = (function (event) {
                event.preventDefault();
                //process element to get resulting track ID, Track ID generated server side to play resulting file.
                let trackData = this.CurrPlaying.src.indexOf(""); // TODO find way to indentify clickec track within howl system v2
                this.skipTo(trackData);
            }).bind(this);
        }
        controlElement.addEventListener(customEvent, EventFunction, this);
    }

    HandleSeekHook(controlElement, customEvent, customFunction = null) {
        let EventFunction;
        if(customFunction){
            EventFunction = customFunction;
        } else {
            EventFunction = (function (event) {
                event.preventDefault();
                let percentage = controlElement.value / 100;
                this.seek(percentage);
            }).bind(this).bind(controlElement);
        }
        controlElement.addEventListener(customEvent, EventFunction, this);
    }

    HandleCloseHook(controlElement, customEvent, customFunction = null) {
        let EventFunction;
        if(customFunction){
            EventFunction = customFunction;
        } else {
            EventFunction = (function (event) {
                event.preventDefault()
                this.close();
            }).bind(this);
        }
        controlElement.addEventListener(customEvent, EventFunction, this);
    }

    HandleMinimiseHook(controlElement, customEvent, customFunction = null) {
        let EventFunction;
        if(customFunction){
            EventFunction = customFunction;
        } else {
            EventFunction = (function (event) {
                event.preventDefault()
                this.Minimise();
            }).bind(this);
        }
        controlElement.addEventListener(customEvent, EventFunction, this);
    }

    Minimise() {
        //TODO if in overlay or fixed, hide the player else do nothing v2
    }

    HandleTrackTitleHook(controlElement, customEvent, customFunction = null) {
        let EventFunction;
        if(customFunction){
            EventFunction = customFunction;
        } else {
            EventFunction = (function (event) {
                event.preventDefault();
            }).bind(this);
        }
        controlElement.addEventListener(customEvent, EventFunction, this);
    }

    HandleTrackTimeHook(controlElement, customEvent, customFunction = null) {
        let EventFunction;
        if(customFunction){
            EventFunction = customFunction;
        } else {
            EventFunction = (function (event) {
                event.preventDefault();
            }).bind(this);
        }
        controlElement.addEventListener(customEvent, EventFunction, this);
    }

    HandleTrackLengthHook(controlElement, customEvent, customFunction = null) {
        let EventFunction;
        if(customFunction){
            EventFunction = customFunction;
        } else {
            EventFunction = (function (event) {
                event.preventDefault();
            }).bind(this);
        }
        controlElement.addEventListener(customEvent, EventFunction, this);
    }

    HandleVolumeBtnHook(controlElement, customEvent, customFunction = null) {
        let EventFunction;
        if(customFunction){
            EventFunction = customFunction;
        } else {
            EventFunction = (function (event) {
                event.preventDefault();
                if(this.isMuted){
                    this.unmute();
                } else {
                    this.mute();
                }
            }).bind(this);
        }
        controlElement.addEventListener(customEvent, EventFunction, this);
    }

    HandleVolumeBarBtnHook(controlElement, customEvent, customFunction = null) {
        let EventFunction;
        if(customFunction){
            EventFunction = customFunction;
        } else {
            EventFunction = (function (event) {
                event.preventDefault();
                let volumePercentage = controlElement.value || 0;
                let VolumeBtn = this.parentElement.querySelector('#'+this.ControlsConfig.volumeBtn);
                this.setCSSVariable('volumeProgress', volumePercentage+'%');
                if(volumePercentage > 0){
                    if(!VolumeBtn.classList.contains('fa-volume-high')){
                        VolumeBtn.classList.toggle('fa-volume-high');
                    }
                    if(VolumeBtn.classList.contains('fa-volume-xmark')){
                        VolumeBtn.classList.toggle('fa-volume-xmark');
                    }
                } else {
                    if(!VolumeBtn.classList.contains('fa-volume-xmark')){
                        VolumeBtn.classList.toggle('fa-volume-xmark');
                    }
                    if(VolumeBtn.classList.contains('fa-volume-high')){
                        VolumeBtn.classList.toggle('fa-volume-high');
                    }
                }
                this.volumeUpdate(volumePercentage);
            }).bind(this);
        }
        controlElement.addEventListener(customEvent, EventFunction, this);
    }

    HandleFastForwardHook(controlElement, customEvent, customFunction = null) {
        let EventFunction;
        if(customFunction){
            EventFunction = customFunction;
        } else {
            EventFunction = (function (event) {
                event.preventDefault();
                this.fastForward();
            }).bind(this);
        }
        controlElement.addEventListener(customEvent, EventFunction, this);
    }

    HandleRewindHook(controlElement, customEvent, customFunction = null) {
        let EventFunction;
        if(customFunction){
            EventFunction = customFunction;
        } else {
            EventFunction = (function (event) {
                event.preventDefault();
                this.rewind();
            }).bind(this);
        }
        controlElement.addEventListener(customEvent, EventFunction, this);
    }
    HandleShowHook(controlElement, customEvent, customFunction = null) {
        let EventFunction;
        if(customFunction){
            EventFunction = customFunction;
        } else {
            EventFunction = (function (event) {
                event.preventDefault();
                this.show();
            }).bind(this);
        }
        controlElement.addEventListener(customEvent, EventFunction, this);
    }

    close() {
        //TODO switch to inline if not inline v2
    }

    ShowPlaylistMenu() {
        //TODO v2 self explanatory hook
    }
    HidePlaylistMenu() {
        //TODO v2 self explanatory hook
    }

    stop() {
        if(this.CurrPlaying.playing()){
            this.CurrPlaying.stop();
        }
    }

    formatTime(seconds) {
        let formattedTime;
        let minutes = Math.floor(seconds/60);
        formattedTime = minutes + ':';
        if(seconds - minutes * 60 < 10){
            formattedTime += '0';
        }
        formattedTime += seconds - minutes * 60
        return formattedTime;
    }


    show() {
        //TODO if not inline and hidden, add class to reveal player.
    }

    HandleCustomControl(controlKey, controlID, CustomControlData, customFunction) {
        //TODO setup custom control hook to find given element and setup customEvent for it. v2
    }

    GenerateDefaultControl(controlKey) {
        //TODO Finish Setting up cases for if control is not found in setup. v2
        switch (controlKey) {
            case 'play':

                break;
            case 'next':

                break;
            case 'prev':

                break;
            case 'pause':

                break;
            case 'stop':

                break;
            case 'playlistHideButton':

                break;
            case 'playlistShowButton':

                break;
            case 'playlistBtns':

                break;
            case 'seek':

                break;
            case 'close':

                break;
            case 'minimise':

                break;
            case 'show':

                break;
            case 'volumeBar':

                break;
            case 'volumeBarBtn':

                break;
            case 'volumeBtn':

                break;
            case 'trackTime':

                break;
            case 'trackLength':

                break;
            case 'trackTitle':

                break;
            case 'fastForward':

                break;
            case 'rewind':

                break;
        }
    }

    SetupControlEventHandling(controlKey, controlID, customEvent = 'click') {
        let controlElement = this.parentElement.querySelector('#'+controlID);
        switch (controlKey) {
            case 'play':
                this.HandlePlayHook(controlElement, customEvent);
                break;
            case 'next':
                this.HandleNextHook(controlElement, customEvent);
                break;
            case 'prev':
                this.HandlePrevHook(controlElement, customEvent);
                break;
            case 'pause':
                this.HandlePauseHook(controlElement, customEvent);
                break;
            case 'stop':
                this.HandleStopHook(controlElement, customEvent);
                break;
            case 'playlistHideButton':
                this.HandlePlaylistHideButtonHook(controlElement, customEvent);
                break;
            case 'playlistShowButton':
                this.HandlePlaylistShowButtonHook(controlElement, customEvent);
                break;
            case 'playlistBtns':
                this.HandlePlaylistBtnHook(controlElement, customEvent);
                break;
            case 'seek':
                this.HandleSeekHook(controlElement, 'input');
                break;
            case 'close':
                this.HandleCloseHook(controlElement, customEvent);
                break;
            case 'minimise':
                this.HandleMinimiseHook(controlElement, customEvent);
                break;
            case 'show':
                this.HandleShowHook(controlElement, customEvent);
                break;
            case 'volumeBar':
                this.HandleVolumeBarBtnHook(controlElement, 'input');
                break;
            case 'volumeBarBtn':
                this.HandleVolumeBarBtnHook(controlElement, customEvent);
                break;
            case 'volumeBtn':
                this.HandleVolumeBtnHook(controlElement, customEvent);
                break;
            case 'fastForward':
                this.HandleFastForwardHook(controlElement, customEvent);
                break;
            case 'rewind':
                this.HandleRewindHook(controlElement, customEvent);
                break;
            case 'trackTime':
                this.HandleTrackTimeHook(controlElement, customEvent);
                break;
            case 'trackLength':
                this.HandleTrackLengthHook(controlElement, customEvent);
                break;
            case 'trackTitle':
                this.HandleTrackTitleHook(controlElement, customEvent);
                break;
            case 'repeatButton':
                this.HandleRepeatButton(controlElement, customEvent);
                break;
            default:
                this.HandleCustomControl(controlKey, controlElement, customEvent);
                break;
        }
    }


    handlePlayerError() {

    }

    getCSSVariable(varName){
        return document.querySelector(':root').getPropertyValue('--'+varName);
    }

    setCSSVariable(varName, varValue){
        document.querySelector(':root').style.setProperty('--'+varName, varValue);
    }

    handleUnlock() {

    }

    handleNextTrack() {
        let endOfPlaylist = this.AudioFiles.length >= this.index + 1;

        if(endOfPlaylist && this.keepPlayingLoop){
            this.next();
        } else if(this.keepPlayingOne){
            this.resetTrack();
        } else if(endOfPlaylist){
            this.stop();
        } else {
            this.next();
        }
    }

    HandleRepeatButton(controlElement, customEvent, customFunction = null) {
        let EventFunction;
        if(customFunction){
            EventFunction = customFunction;
        } else {
            EventFunction = (function (event) {
                event.preventDefault();
                this.toggleRepeatState();
            }).bind(this);
        }
        controlElement.addEventListener(customEvent, EventFunction, this);
    }

    toggleRepeatState() {
        if(this.keepPlayingLoop === false){
            this.keepPlayingLoop = true;
            this.keepPlayingOne = false;
        } else if (this.keepPlayingLoop === true){
            this.keepPlayingLoop = false;
            this.keepPlayingOne = true;
        } else {
            this.keepPlayingLoop = false;
            this.keepPlayingOne = false;
        }
    }
}